import clsx from "clsx";
import {
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    TwitterShareButton
} from "react-share";
import { FaXTwitter, FaFacebookF, FaLinkedinIn, FaWhatsapp } from "react-icons/fa6";



type TRMDRSocialShare = {

    shareButtonClasssName?:string;

    title?:string|null;
    contentRouteNavigationURL?:string|null;

}


const RMDRSocialShare = ( props:TRMDRSocialShare ) => {

    return (
        <>
            <FacebookShareButton
                url={`${window.location.origin}${props?.contentRouteNavigationURL}`}
                title={props.title||""}
                windowHeight={600}
                windowWidth={800}
                className={clsx("share-facebook", props.shareButtonClasssName)}
            >
                <FaFacebookF className="fs-6" />
            </FacebookShareButton>

            <TwitterShareButton
                url={`${window.location.origin}${props?.contentRouteNavigationURL}`}
                title={props.title||""}
                windowHeight={600}
                windowWidth={800}
                className={clsx("share-twitter-x", props.shareButtonClasssName)}
            >
                <FaXTwitter className="fs-6" />
            </TwitterShareButton>

            <LinkedinShareButton
                url={`${window.location.origin}${props?.contentRouteNavigationURL}`}
                title={props.title||""}
                windowHeight={600}
                windowWidth={800}
                className={clsx("share-linkedin", props.shareButtonClasssName)}
            >
                <FaLinkedinIn className="fs-6" />
            </LinkedinShareButton>

            <WhatsappShareButton
                url={`${window.location.origin}${props?.contentRouteNavigationURL}`}
                title={props.title||""}
                separator=":: "
                windowHeight={600}
                windowWidth={800}
                className={clsx("share-whatsapp", props.shareButtonClasssName)}
            >
                <FaWhatsapp className="fs-6" />
            </WhatsappShareButton>
        </>
    )

}

export default RMDRSocialShare;